(function () {
  var YOTPO_APP_KEY = 'Ioh4q2i1hYPxfsXa70UJV30ezP7GCp6PGQluCzib';
  var maxAttempts = 40;
  var attempts = 0;
  var observerBound = false;

  function initYotpoWidgets() {
    var ready = false;
    try {
      if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
        window.yotpo.initWidgets();
        ready = true;
      }
    } catch (e) {
      /* Yotpo double-load can throw on iOS Safari — fall through to API fallbacks */
    }
    try {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
        ready = true;
      }
    } catch (e) {
      /* same as above */
    }
    return ready;
  }

  function poll() {
    if (initYotpoWidgets() || ++attempts >= maxAttempts) return;
    window.setTimeout(poll, 250);
  }

  function formatReviewCount(total) {
    return Number(total).toLocaleString('en-US') + ' Reviews';
  }

  function starSvg(filled) {
    var fill = filled ? '#e7721b' : '#ffffff';
    return (
      '<span class="rb-product-stars-fallback__star" aria-hidden="true">' +
        '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="18" height="18" focusable="false">' +
          '<path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#e7721b" fill="' + fill + '"></path>' +
        '</svg>' +
      '</span>'
    );
  }

  /* True only when our SVG stars, or Yotpo glyphs with a loaded icon font, are present */
  function yotpoIconFontReady() {
    try {
      if (!document.fonts || typeof document.fonts.check !== 'function') return true;
      return document.fonts.check('16px yotpo-widget-font');
    } catch (e) {
      return true;
    }
  }

  function hasRenderableStars(el) {
    if (el.querySelector('.rb-product-stars-fallback__star svg')) return true;
    if (!yotpoIconFontReady()) return false;
    var icons = el.querySelectorAll('.yotpo-icon-star, .yotpo-icon-half-star, .yotpo-icon-empty-star');
    for (var i = 0; i < icons.length; i++) {
      var rect = icons[i].getBoundingClientRect();
      if (rect.width > 2 && rect.height > 2) return true;
    }
    return false;
  }

  function renderFallbackStars(el, averageScore, totalReviews) {
    var filled = Math.min(5, Math.max(0, Math.round(Number(averageScore) || 0)));
    var stars = '';
    for (var i = 0; i < 5; i++) stars += starSvg(i < filled);

    el.innerHTML =
      '<div class="yotpo-display-wrapper" style="visibility:visible">' +
        '<div class="standalone-bottomline star-clickable rb-product-stars-fallback">' +
          '<div class="yotpo-bottomline yotpo-bottomline-pull-left">' +
            '<div class="rb-product-stars-fallback__row">' +
              '<span class="rb-product-stars-fallback__stars" aria-hidden="true">' + stars + '</span>' +
              '<span class="text-m">' + formatReviewCount(totalReviews) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    el.setAttribute('data-rb-stars-ready', '1');
  }

  function fetchAndRender(el) {
    var productId = el.getAttribute('data-product-id');
    if (!productId) return;

    var cached = el.getAttribute('data-rb-stars-score');
    var cachedTotal = el.getAttribute('data-rb-stars-total');
    if (cached && cachedTotal) {
      renderFallbackStars(el, cached, cachedTotal);
      return;
    }

    if (el.getAttribute('data-rb-stars-loading') === '1') return;
    el.setAttribute('data-rb-stars-loading', '1');

    var appKey = el.getAttribute('data-appkey') || YOTPO_APP_KEY;
    fetch('https://api.yotpo.com/products/' + encodeURIComponent(appKey) + '/' + encodeURIComponent(productId) + '/bottomline')
      .then(function (response) {
        if (!response.ok) throw new Error('bottomline failed');
        return response.json();
      })
      .then(function (payload) {
        var bottomline = payload && payload.response && payload.response.bottomline;
        el.removeAttribute('data-rb-stars-loading');
        if (!bottomline || !bottomline.total_reviews) return;
        el.setAttribute('data-rb-stars-score', String(bottomline.average_score));
        el.setAttribute('data-rb-stars-total', String(bottomline.total_reviews));
        renderFallbackStars(el, bottomline.average_score, bottomline.total_reviews);
      })
      .catch(function () {
        el.removeAttribute('data-rb-stars-loading');
      });
  }

  function hydrateProductCardStars() {
    document.querySelectorAll('.rb-product-cards .yotpo.bottomLine[data-product-id]').forEach(function (el) {
      if (hasRenderableStars(el)) {
        el.setAttribute('data-rb-stars-ready', '1');
        return;
      }
      fetchAndRender(el);
    });
  }

  /* PDP variant-box Yotpo SR stars: rewrite SVG attrs (CSS alone is easy to miss / get reset) */
  var PDP_STAR_PX = '20';
  function sizePdpVariantStars() {
    if (!document.body.classList.contains('template-product')) return;
    var root = document.querySelector('.t4s-product__info-container, .t4s-product__info-wrapper');
    if (!root) return;
    root.querySelectorAll('svg.star-container, svg.yotpo-sr-star-full, svg.yotpo-sr-star-half, svg.yotpo-sr-star-empty').forEach(function (svg) {
      svg.setAttribute('width', PDP_STAR_PX);
      svg.setAttribute('height', PDP_STAR_PX);
      svg.style.setProperty('width', PDP_STAR_PX + 'px', 'important');
      svg.style.setProperty('height', PDP_STAR_PX + 'px', 'important');
      svg.style.setProperty('min-width', PDP_STAR_PX + 'px', 'important');
      svg.style.setProperty('min-height', PDP_STAR_PX + 'px', 'important');
    });
    root.querySelectorAll('.yotpo-sr-bottom-line-text, .yotpo-sr-bottom-line-right-panel, .yotpo-sr-bottom-line-text span, .text-m').forEach(function (el) {
      el.style.setProperty('font-size', '16.5px', 'important');
    });
  }

  function schedulePdpVariantStars() {
    sizePdpVariantStars();
    window.setTimeout(sizePdpVariantStars, 400);
    window.setTimeout(sizePdpVariantStars, 1200);
    window.setTimeout(sizePdpVariantStars, 3000);
    window.setTimeout(sizePdpVariantStars, 6000);
  }

  function bindStarObserver() {
    if (observerBound || typeof MutationObserver === 'undefined') return;
    observerBound = true;

    var timer = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        hydrateProductCardStars();
        sizePdpVariantStars();
      }, 200);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'width', 'height'],
    });
  }

  /* Injected card grids (You May Also Like) need this the moment they land, rather than waiting
     out the observer's 200ms debounce. */
  window.rbHydrateProductCardStars = hydrateProductCardStars;

  function scheduleProductStars() {
    hydrateProductCardStars();
    schedulePdpVariantStars();
    window.setTimeout(hydrateProductCardStars, 600);
    window.setTimeout(hydrateProductCardStars, 1500);
    window.setTimeout(hydrateProductCardStars, 3000);
    window.setTimeout(hydrateProductCardStars, 6000);
  }

  /* rb-reviews-live-v1 — the footer shows Yotpo's live total (product + site reviews), never a
     rounded marketing figure. The last total is cached so repeat visits paint it immediately. */
  var REVIEW_COUNT_KEY = 'rb-review-total';

  function cachedReviewCount() {
    try {
      return Number(window.localStorage.getItem(REVIEW_COUNT_KEY)) || 0;
    } catch (err) {
      return 0;
    }
  }

  function formatFooterReviewCount(totalReviews) {
    return totalReviews ? Number(totalReviews).toLocaleString('en-US') : '&nbsp;';
  }

  function renderFooterFallback(host, averageScore, totalReviews) {
    if (!host) return;

    var filled = Math.min(5, Math.max(0, Math.round(Number(averageScore) || 5)));
    var stars = '';
    for (var i = 0; i < 5; i++) stars += starSvg(i < filled);
    var label = totalReviews ? formatReviewCount(totalReviews) : 'Certified reviews';

    host.innerHTML =
      '<a class="rb-footer-reviews-fallback" href="/pages/reviews" aria-label="' +
        label +
        ' — view reviews">' +
        '<div class="rb-footer-reviews-fallback__count">' + formatFooterReviewCount(totalReviews) + '</div>' +
        '<div class="rb-footer-reviews-fallback__label">Certified Reviews</div>' +
        '<div class="rb-footer-reviews-fallback__stars" aria-hidden="true">' + stars + '</div>' +
      '</a>';
    host.setAttribute('data-rb-footer-ready', '1');
  }

  function hydrateFooterBadge() {
    var host = document.querySelector('.rb-footer__yotpo');
    if (!host) return;
    if (host.getAttribute('data-rb-footer-ready') !== '1') {
      renderFooterFallback(host, 5, cachedReviewCount());
    }
    if (host.getAttribute('data-rb-footer-loading') === '1') return;
    host.setAttribute('data-rb-footer-loading', '1');

    var reviewsUrl = 'https://api.yotpo.com/v1/widget/' + YOTPO_APP_KEY + '/reviews.json?per_page=1&page=1';
    var siteUrl = 'https://api.yotpo.com/v1/widget/' + YOTPO_APP_KEY + '/products/yotpo_site_reviews/bottomline';
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var signal = controller ? controller.signal : undefined;
    var timeoutId = window.setTimeout(function () {
      if (controller) controller.abort();
      host.removeAttribute('data-rb-footer-loading');
    }, 8000);

    function fetchJson(url) {
      return fetch(url, signal ? { signal: signal } : undefined).then(function (r) {
        if (!r.ok) throw new Error('bad status');
        return r.json();
      });
    }

    Promise.all([
      fetchJson(reviewsUrl),
      fetchJson(siteUrl).catch(function () { return null; }),
    ])
      .then(function (results) {
        window.clearTimeout(timeoutId);
        host.removeAttribute('data-rb-footer-loading');

        var payload = results[0];
        var sitePayload = results[1];
        var response = payload && payload.response;
        var productTotal = response && response.pagination && response.pagination.total
          ? Number(response.pagination.total)
          : response && response.bottomline && response.bottomline.total_review
            ? Number(response.bottomline.total_review)
            : 0;
        var siteBottom = sitePayload && sitePayload.response && sitePayload.response.bottomline;
        var siteTotal = siteBottom && siteBottom.total_review ? Number(siteBottom.total_review) : 0;
        var total = productTotal + siteTotal;
        var score = response && response.bottomline && response.bottomline.average_score
          ? response.bottomline.average_score
          : 5;
        if (!total) return;
        try {
          window.localStorage.setItem(REVIEW_COUNT_KEY, String(total));
        } catch (err) {}
        renderFooterFallback(host, score, total);
      })
      .catch(function () {
        window.clearTimeout(timeoutId);
        host.removeAttribute('data-rb-footer-loading');
      });
  }

  function scheduleFooterBadge() {
    hydrateFooterBadge();
    window.setTimeout(hydrateFooterBadge, 1500);
    window.setTimeout(hydrateFooterBadge, 4000);
    window.setTimeout(hydrateFooterBadge, 8000);
  }

  poll();
  scheduleProductStars();
  scheduleFooterBadge();
  bindStarObserver();

  window.addEventListener('load', function () {
    poll();
    scheduleProductStars();
    scheduleFooterBadge();
  });
  document.addEventListener('shopify:section:load', function () {
    poll();
    hydrateProductCardStars();
    hydrateFooterBadge();
  });

  window.rbHydrateProductStars = hydrateProductCardStars;
})();